export const EditMarkIcon = (props) => (
  <svg fill="none" height={18} viewBox="0 0 18 18" width={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.82353 4.76471H2.88235C2.38312 4.76471 1.90434 4.96303 1.55133 5.31604C1.19832 5.66905 1 6.14783 1 6.64706V15.1177C1 15.6169 1.19832 16.0957 1.55133 16.4487C1.90434 16.8017 2.38312 17 2.88235 17H11.3529C11.8522 17 12.331 16.8017 12.684 16.4487C13.037 16.0957 13.2353 15.6169 13.2353 15.1177V14.1765"
      stroke={props.color ? props.color : "#667085"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.41176}
    />
    <path
      d="M12.2933 2.88245L15.1168 5.70598M16.4204 4.37422C16.7911 4.00354 16.9993 3.50079 16.9993 2.97657C16.9993 2.45235 16.7911 1.9496 16.4204 1.57892C16.0497 1.20825 15.5469 1 15.0227 1C14.4985 1 13.9958 1.20825 13.6251 1.57892L5.70508 9.47069V12.2942H8.52861L16.4204 4.37422Z"
      stroke={props.color ? props.color : "#667085"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.41176}
    />
  </svg>
);
